import { render, staticRenderFns } from "./disease_page.vue?vue&type=template&id=d88df6da&scoped=true&"
import script from "./disease_page.vue?vue&type=script&lang=js&"
export * from "./disease_page.vue?vue&type=script&lang=js&"
import style0 from "./disease_page.vue?vue&type=style&index=0&id=d88df6da&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d88df6da",
  null
  
)

export default component.exports